import BnccExamSessionsTablePresentation from "home/components/bncc_exam/presentations/sessions_table_presentation"
import BnccExamPerformanceByAreaChartPresentation from "home/components/bncc_exam/presentations/performance_by_area_chart_presentation"

export { BnccExamSessionsTablePresentation, BnccExamPerformanceByAreaChartPresentation }
